
      import { initCloudyLayout } from './js/modules/cloudy-layout.js';

      // Initialize the app
      document.addEventListener('DOMContentLoaded', async () => {
        try {
          // Initialize layout
          await initCloudyLayout();

          // Remove loading screen with fade
          const loader = document.querySelector('.initial-load');
          loader.classList.add('fade-out');
          setTimeout(() => loader.remove(), 300);
        } catch (error) {
          console.error('Failed to initialize app:', error);
        }
      });

      // Register service worker
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('/sw.js')
          .catch(error => console.error('Service worker registration failed:', error));
      }
    